<nav class="navbar fixed-top navbar-toggleable-md navbar-dark nav-shadow nav-background">
    <div>
        <span *ngIf="user" class="toggle-menu mr-3" (click)="onToggleSidebar()">
            <fa-icon icon="bars" aria-hidden="true"></fa-icon>
        </span>
        <a class="navbar-brand" routerLink="{{homeUrl}}">
            <!-- <span>PCS Malta</span> -->
            <img src="/assets/img/logo.png" alt="{{'PCS Malta' | translate}}">
            <span></span>
        </a>
    </div>
    <div *ngIf="environmentName" class="setting simple-pill" [ngClass]="environmentName">
        {{ environmentName }}
    </div>
    <div class="ml-auto mr-5">
        <button id="dark-theme-toggle" class="btn-link" (click)="toggleDarkMode()">
            <fa-icon icon="adjust" class="mr-1" [ngClass]="{'text-white':dark}"></fa-icon>
            <span class="text-primary">{{dark ? 'Switch to light mode' : 'Switch to dark mode'}}</span>
        </button>
    </div>
    <div *ngIf="user">
        <div ngbDropdown display="dynamic" placement="bottom-right" class="d-inline-block user">
            <button class="btn-link user-dd-trigger" id="dropdownBasic1" ngbDropdownToggle>
                <span class="initials">{{user.fullName | initials}}</span>
                <span class="name ml-1 mr-1">{{ user.fullName ? user.fullName : user.userName }}</span>
                <span>{{ user?.organization?.name ? '(' + user.organization.name + ')' : ''}}</span>
                <fa-icon icon="angle-down" class="text-primary"></fa-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <a class="dropdown-item" [routerLink]="['user-account/view', user.id]"><fa-icon icon="user"></fa-icon>&nbsp;{{'Account' | translate}}</a>
                <div tabindex="-1" class="dropdown-divider"></div>
                <button class="dropdown-item" (click)="logout()"><fa-icon icon="sign-out-alt"></fa-icon>&nbsp;{{'Sign Out' | translate}}</button>
            </div>
        </div>
    </div>
</nav>
